import React from 'react';

const Spacer = () => <div style={{ flexGrow: 100 }} />;

export default Spacer;
